import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Y si no sé nada de IA?',
  answer: 'No necesitas saber nada. Te damos los prompts exactos que debes copiar y pegar. La IA hace todo el trabajo técnico, tú solo sigues las instrucciones paso a paso.'
}, {
  question: '¿Y si no tengo seguidores?',
  answer: 'Perfecto. Este sistema incluye estrategias para vender sin audiencia. Aprenderás a usar grupos, WhatsApp y otras plataformas donde ya están tus clientes ideales esperando.'
}, {
  question: '¿Y si solo tengo iPhone/Android?',
  answer: 'Todo el sistema está diseñado para funcionar desde tu celular. No necesitas computadora, programas complicados ni nada más que tu teléfono y conexión a internet.'
}, {
  question: '¿Cuánto tiempo necesito al día?',
  answer: 'Con 1-2 horas al día es suficiente. El sistema está diseñado para mamás ocupadas. La IA hace el trabajo pesado, tú solo guías el proceso.'
}, {
  question: '¿Esto sirve si trabajo o cuido niños?',
  answer: 'Absolutamente. Fue creado específicamente para mamás con poco tiempo. Puedes avanzar en bloques cortos, incluso mientras los niños duermen o juegan.'
}, {
  question: '¿Necesito invertir en publicidad?',
  answer: 'No. Te enseñamos estrategias orgánicas y gratuitas para conseguir tus primeras ventas. Puedes escalar con publicidad después si quieres, pero no es necesario para empezar.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Inmediatamente después del pago recibes acceso por email. Todo es digital, puedes empezar en los próximos 5 minutos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl md:text-4xl text-dark text-center mb-12" data-id="element-64">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="border border-border rounded-lg overflow-hidden" data-id="element-66">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-67">
                <span className="font-semibold text-lg text-dark pr-4" data-id="element-68">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-69">
                  <ChevronDown className="w-5 h-5 text-body flex-shrink-0" data-id="element-70" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-71">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-72">
                    <div className="px-6 pb-6 text-body" data-id="element-73">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}